import { rest } from 'msw';
import { getEnv } from 'util/getEnv';
import {
  activeCustomersCardsFixture,
  activeCustomersDistributionsFixture,
  activeCustomersGridFixture,
  activeCustomersMemberTrendsFixture,
  activeCustomersVioTrendsFixture,
} from './fixtures/active-customers.fixture';
import {
  slidersGridFixture,
  slidersMemberTrendsFixture,
  slidersVioTrendsFixture,
  slidingCardsFixture,
} from './fixtures/sliders.fixture';
import {
  churnCardsFixture,
  churnedGridFixture,
  churnedMemberTrendsFixture,
  churnedVioTrendsFixture,
} from './fixtures/churned.fixture';
import {
  detailsCardsFixture,
  detailsFixture,
  guestJourneyCustomerExportFixture,
} from './fixtures/details.fixture';
import {
  stageMovementCardsFixture,
  stageMovementDataFixture,
} from './fixtures/stage-movement.fixture';
import {
  guestJourneyOffersFixture,
  offerImpactCardsFixture,
  offerImpactSankeyFixture,
} from './fixtures/offer-impact.fixture';
import {
  retentionCardsFixture,
  retentionConversionTrendsFixture,
} from './fixtures/retention.fixture';
import {
  benchmarksOverviewFixture,
  benchmarksMetricsFixture,
  benchmarkTimeframesFixture,
} from './fixtures/benchmarks.fixture';

/** Card endpoints live under the BE's `/v2` base (see the API reconciliation doc). */
const v2BaseUrl = () =>
  `${getEnv('REACT_APP_ADMIN_API_URL')}/incentivio-reports/v2/guest-journey`;

export const getActiveCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/active/summary`, fn);

export const getActiveInsightsMock = fn =>
  rest.get(`${v2BaseUrl()}/active/insights`, fn);

export const getActiveGridMock = fn =>
  rest.get(`${v2BaseUrl()}/active/overview`, fn);

export const getActiveMemberTrendsMock = fn =>
  rest.get(`${v2BaseUrl()}/active/trends`, fn);

export const getActiveDistributionsMock = fn =>
  rest.get(`${v2BaseUrl()}/active/distributions`, fn);

export const getSlidingCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/sliding/summary`, fn);

export const getSlidersInsightsMock = fn =>
  rest.get(`${v2BaseUrl()}/sliding/insights`, fn);

export const getSlidersGridMock = fn =>
  rest.get(`${v2BaseUrl()}/sliding/overview`, fn);

export const getSlidersMemberTrendsMock = fn =>
  rest.get(`${v2BaseUrl()}/sliding/trends`, fn);

export const getChurnCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/churn/summary`, fn);

export const getChurnedInsightsMock = fn =>
  rest.get(`${v2BaseUrl()}/churn/insights`, fn);

export const getChurnedGridMock = fn =>
  rest.get(`${v2BaseUrl()}/churn/overview`, fn);

export const getChurnedMemberTrendsMock = fn =>
  rest.get(`${v2BaseUrl()}/churn/trends`, fn);

export const getDetailsCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/details/summary`, fn);

export const getDetailsMock = fn => rest.get(`${v2BaseUrl()}/details/data`, fn);

export const exportGuestJourneyDetailsCustomersMock = fn =>
  rest.post(`${v2BaseUrl()}/details/customers/export`, fn);

export const getStageMovementCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/stage-movement/summary`, fn);

export const getStageMovementDataMock = fn =>
  rest.get(`${v2BaseUrl()}/stage-movement/data`, fn);

export const getGuestJourneyOffersMock = fn =>
  rest.get(`${v2BaseUrl()}/offers`, fn);

export const getOfferImpactCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/offer-impact/summary`, fn);

export const getOfferImpactSankeyMock = fn =>
  rest.get(`${v2BaseUrl()}/offer-impact/sankey`, fn);

export const getRetentionCardsMock = fn =>
  rest.get(`${v2BaseUrl()}/retention/summary`, fn);

export const getRetentionConversionTrendsMock = fn =>
  rest.get(`${v2BaseUrl()}/retention/conversion-trends`, fn);

export const getBenchmarksOverviewMock = fn =>
  rest.get(`${v2BaseUrl()}/benchmarks/overview`, fn);

export const getBenchmarksMetricsMock = fn =>
  rest.get(`${v2BaseUrl()}/benchmarks/metrics`, fn);

export const getBenchmarkTimeframesMock = fn =>
  rest.get(`${v2BaseUrl()}/benchmarks/timeframes`, fn);

export const handlers = () => [
  getActiveCardsMock((_req, res, ctx) =>
    res(ctx.json(activeCustomersCardsFixture)),
  ),
  getActiveInsightsMock((_req, res, ctx) =>
    res(ctx.json(activeCustomersVioTrendsFixture)),
  ),
  getActiveGridMock((_req, res, ctx) =>
    res(ctx.json(activeCustomersGridFixture)),
  ),
  getActiveMemberTrendsMock((_req, res, ctx) =>
    res(ctx.json(activeCustomersMemberTrendsFixture)),
  ),
  getActiveDistributionsMock((_req, res, ctx) =>
    res(ctx.json(activeCustomersDistributionsFixture)),
  ),
  getSlidingCardsMock((_req, res, ctx) => res(ctx.json(slidingCardsFixture))),
  getSlidersInsightsMock((_req, res, ctx) =>
    res(ctx.json(slidersVioTrendsFixture)),
  ),
  getSlidersGridMock((_req, res, ctx) => res(ctx.json(slidersGridFixture))),
  getSlidersMemberTrendsMock((_req, res, ctx) =>
    res(ctx.json(slidersMemberTrendsFixture)),
  ),
  getChurnCardsMock((_req, res, ctx) => res(ctx.json(churnCardsFixture))),
  getChurnedInsightsMock((_req, res, ctx) =>
    res(ctx.json(churnedVioTrendsFixture)),
  ),
  getChurnedGridMock((_req, res, ctx) => res(ctx.json(churnedGridFixture))),
  getChurnedMemberTrendsMock((_req, res, ctx) =>
    res(ctx.json(churnedMemberTrendsFixture)),
  ),
  getDetailsCardsMock((_req, res, ctx) => res(ctx.json(detailsCardsFixture))),
  getDetailsMock((_req, res, ctx) => res(ctx.json(detailsFixture))),
  exportGuestJourneyDetailsCustomersMock((_req, res, ctx) =>
    res(ctx.json(guestJourneyCustomerExportFixture)),
  ),
  getStageMovementCardsMock((_req, res, ctx) =>
    res(ctx.json(stageMovementCardsFixture)),
  ),
  getStageMovementDataMock((_req, res, ctx) =>
    res(ctx.json(stageMovementDataFixture)),
  ),
  getGuestJourneyOffersMock((_req, res, ctx) =>
    res(ctx.json(guestJourneyOffersFixture)),
  ),
  getOfferImpactCardsMock((_req, res, ctx) =>
    res(ctx.json(offerImpactCardsFixture)),
  ),
  getOfferImpactSankeyMock((_req, res, ctx) =>
    res(ctx.json(offerImpactSankeyFixture)),
  ),
  getRetentionCardsMock((_req, res, ctx) =>
    res(ctx.json(retentionCardsFixture)),
  ),
  getRetentionConversionTrendsMock((_req, res, ctx) =>
    res(ctx.json(retentionConversionTrendsFixture)),
  ),
  getBenchmarksOverviewMock((_req, res, ctx) =>
    res(ctx.json(benchmarksOverviewFixture)),
  ),
  getBenchmarksMetricsMock((_req, res, ctx) =>
    res(ctx.json(benchmarksMetricsFixture)),
  ),
  getBenchmarkTimeframesMock((_req, res, ctx) =>
    res(ctx.json(benchmarkTimeframesFixture)),
  ),
];
